import { useNavigate, useParams } from "react-router-dom";
import { useWeglotToast } from "src/plugins/weglot";
import { useRemoveAnswersForHiddenQuestions } from "src/scenes/parent/forms/hooks/useRemoveAnswersForHiddenQuestions";
import { useSubmitForm } from "src/scenes/parent/forms/hooks/useSubmitForm";
import { StepProps } from "../components/Layout/FormStepLayout";
import * as Url from "../services/url";
import { useOrganization } from "./useOrganization";

export function useFormSteps({ currentStep, steps }: StepProps) {
  const navigate = useNavigate();
  const organization = useOrganization();
  const { formId = "" } = useParams();

  const toast = useWeglotToast();

  const { submitForm } = useSubmitForm();

  const removeAnswersForHiddenQuestions = useRemoveAnswersForHiddenQuestions({
    formId,
  });
  const handleSubmit = async () => {
    try {
      await removeAnswersForHiddenQuestions();
      await submitForm(formId);

      organization.do((org) => {
        navigate(Url.Parent.index(org));
      });

      toast({
        title: "Hooray!",
        description: "Form successfully submitted.",
        status: "success",
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Error submitting form",
        description:
          "Please try again later or report the problem to our support team.",
        status: "error",
        isClosable: true,
      });
    }
  };

  let onPrevious: () => void;
  if (currentStep === 1) {
    onPrevious = () =>
      organization.do((org) => navigate(Url.Parent.index(org)));
  } else if (currentStep > steps.length) {
    onPrevious = () =>
      organization.do((org) =>
        navigate(Url.Parent.Form.edit(org, formId, steps.length))
      );
  } else {
    onPrevious = () =>
      organization.do((org) =>
        navigate(Url.Parent.Form.edit(org, formId, currentStep - 1))
      );
  }

  let onNext: () => void;
  // the nav state below is used in FormQuestion.tsx::scrollToQuestionAfterNavigate
  if (currentStep === steps.length) {
    // last step
    onNext = handleSubmit;
  } else if (currentStep > steps.length) {
    onNext = () =>
      organization.do((org) => {
        return navigate(Url.Parent.Form.edit(org, formId, steps.length));
      });
  } else {
    onNext = () =>
      organization.do((org) => {
        return navigate(Url.Parent.Form.edit(org, formId, currentStep + 1));
      });
  }

  return { onPrevious, onNext };
}
